import { applyMiddleware, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import promise from "redux-promise-middleware";
import thunk from "redux-thunk";

import reducer from "./reducers";

import { createTransform } from 'redux-persist';
import { reduxErrorMiddleware } from "./middlewares/reduxErrorMiddleware";
import refreshTokenMiddleware from "./middlewares/refreshTokenMiddleware";


const authTransform = createTransform(
  // Transformacion al guardar el estado
  (inboundState) => {
    // Eliminamos propiedades que no queremos persistir
    const { isFetching, didInvalidate, loginMfa, resendMfaCode, ...persistedState } = inboundState;
    return persistedState;
  },
  // Transformacion al recuperar el estado
  (outboundState) => outboundState,
  { whitelist: ['auth'] }
);

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "userPreferences", "versionState"],
  transforms: [authTransform],
};
const persistedReducer = persistReducer(persistConfig, reducer);
const middleware = [
  thunk,
  refreshTokenMiddleware,
  reduxErrorMiddleware,
  promise,
];

export const store = createStore(
  persistedReducer,
  applyMiddleware(...middleware),
);

export const persistor = persistStore(store);